import React from "react";
import { loadStripe } from "@stripe/stripe-js";

const STRIPE_PUBLIC_KEY =
  "pk_live_51MPkbfJ9sARxLQ5AjRXc4d7PPlD1mFrndQI7XtR6raLAUemyO6BulUVu5EpMwMjAl15GGOMrIjNqqTN8MvosKNND001FmYHHck";
const STRIPE_PUBLIC_KEYS = [
  "pk_live_51MPkbfJ9sARxLQ5AjRXc4d7PPlD1mFrndQI7XtR6raLAUemyO6BulUVu5EpMwMjAl15GGOMrIjNqqTN8MvosKNND001FmYHHck",
  "pk_test_51MPkbfJ9sARxLQ5A0hXji71gWaXrHbuCk3TVLsEjmQ3hXPht6FHcG7c9AU3XXIdNgAMshdz02Mrmx3UfhYvff1RS002JJVUtBu",
];
//"pk_test_51MPkbfJ9sARxLQ5A0hXji71gWaXrHbuCk3TVLsEjmQ3hXPht6FHcG7c9AU3XXIdNgAMshdz02Mrmx3UfhYvff1RS002JJVUtBu";
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

const successUrl = "https://score.qualifiedfinancial.com/success";
const cancelUrl = "https://score.qualifiedfinancial.com/cancel";

function CheckoutButton(props) {
  // console.log(props.children);
  const handleClick = async () => {
    const stripe = await stripePromise;
    const payPrice = "price_1Oby6tJ9sARxLQ5AMZKwR3Mw";
    // const payPrice = "price_1NiiblJ9sARxLQ5AYmhMtWL3";
    const subPrice = "price_1NiiblJ9sARxLQ5AYmhMtWL3";
    const price = props.Mode === "payment" ? payPrice : subPrice;
    const clientReferenceId = `${props.UserID}*${props.ArrayIndex}*${props.TimeStamp}`;
    // "https://buy.stripe.com/5kAcQxemObCzeUEbII"
    const options = {
      lineItems: [
        {
          price: price,
          quantity: 1,
        },
      ],
      mode: props.Mode,
      successUrl: successUrl,
      cancelUrl: cancelUrl,
      clientReferenceId: clientReferenceId,
    };
    // console.log("Options:", options);
    const { error } = await stripe.redirectToCheckout(options);

    if (error) {
      console.error("Error:", error);
    }
  };
  if (props.children !== undefined) {
    return <div onClick={handleClick}>{props.children}</div>;
  }

  return (
    <div
      onClick={handleClick}
      className="NewProfileButton hoverBox"
      style={{ margin: "auto" }}
    >
      {props.Label}
    </div>
  );
}

export default CheckoutButton;
